import { Alert, Box, Grid, Paper, Stack, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import AuthLogin from "./AuthLogin";
import ResetPasswordScreen from "./ResetPasswordScreen";
import ForgotPasswordScreen from "./ForgotPasswordScreen";
import TwoFactorAuthScreen from "./TwoFactorAuthScreen";

function Login() {
  const [loginFormData, setLoginFormData] = useState({});

  const [ResetPasswordScreenIsOpen, setResetPasswordScreenIsOpen] = useState(false);
  const [ForgotPasswordScreenIsOpen, setForgotPasswordScreenIsOpen] = useState(false);
  const [TwoFactorAuthScreenIsOpen, setTwoFactorAuthScreenIsOpen] = useState(false);
  const [twoFactorData, setTwoFactorData] = useState({});
  const [resultData, setResultData] = React.useState(false);
  const [errMsg, seterrMsg] = React.useState("");

  useEffect(() => {
    // Check if there's a pending 2FA session before clearing
    const savedTwoFactorAuthScreenIsOpen = sessionStorage.getItem("twoFactorAuthScreenIsOpen");
    const savedTwoFactorData = sessionStorage.getItem("twoFactorData");
    const savedLoginFormData = sessionStorage.getItem("loginFormData");

    if (savedTwoFactorAuthScreenIsOpen === "true" && savedTwoFactorData) {
      // Restore 2FA state from sessionStorage
      setTwoFactorData(JSON.parse(savedTwoFactorData));
      setLoginFormData(savedLoginFormData ? JSON.parse(savedLoginFormData) : {});
      setTwoFactorAuthScreenIsOpen(true);
    } else {
      // Only clear localStorage if not restoring 2FA session
      localStorage.clear();
    }
  }, []);

  const closeLoginAlert = () => {
    setResultData(false);
    seterrMsg("");
  };

  return (
    <Box sx={{ minHeight: "100vh" }}>
      {/* <AuthBackground /> */}
      <Grid
        container
        direction="column"
        justifyContent="flex-end"
        sx={{
          minHeight: "100vh"
        }}
      >
        <Grid item xs={12} sx={{ ml: 3, mt: 1 }}>
          <img
            width={"200px"}
            src={"http://13.231.17.170:8080/images/enterprise/get?filename=wilstark_logo.png"}
          />
          <Box sx={{ width: "500px" }}></Box>
        </Grid>

        <Grid item xs={12}>
          <Grid
            item
            xs={12}
            container
            justifyContent="center"
            alignItems="center"
            sx={{ minHeight: { xs: "calc(100vh - 134px)", md: "calc(100vh - 112px)" } }}
          >
            <Grid item sx={{ maxWidth: "500px" }}>
              <Paper className="p-5">
                {resultData && errMsg && (
                  <Alert
                    id="login-alert"
                    severity={String(resultData).toLowerCase()}
                    onClose={closeLoginAlert}
                    sx={{ mb: 3 }}
                  >
                    {errMsg}
                  </Alert>
                )}
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <Stack
                      direction="row"
                      justifyContent="space-between"
                      alignItems="baseline"
                      sx={{ mb: { xs: -0.5, sm: 0.5 } }}
                    >
                      <Typography variant="h5">Login</Typography>
                      <Typography
                        component={"a"}
                        to="/register"
                        variant="body1"
                        sx={{ textDecoration: "none" }}
                        color="primary"
                      >
                        Don&apos;t have an account?
                      </Typography>
                    </Stack>
                  </Grid>
                  <Grid item xs={12}>
                    {!ResetPasswordScreenIsOpen && !TwoFactorAuthScreenIsOpen && (
                      <AuthLogin
                        ResetPasswordScreenIsOpen={ResetPasswordScreenIsOpen}
                        setResetPasswordScreenIsOpen={setResetPasswordScreenIsOpen}
                        loginFormData={loginFormData}
                        setLoginFormData={setLoginFormData}
                        resultData={resultData}
                        seterrMsg={seterrMsg}
                        setResultData={setResultData}
                        ForgotPasswordScreenIsOpen={ForgotPasswordScreenIsOpen}
                        setForgotPasswordScreenIsOpen={setForgotPasswordScreenIsOpen}
                        twoFactorData={twoFactorData}
                        setTwoFactorData={setTwoFactorData}
                        setTwoFactorAuthScreenIsOpen={setTwoFactorAuthScreenIsOpen}
                      />
                    )}
                  </Grid>
                </Grid>
              </Paper>
            </Grid>
          </Grid>
        </Grid>

        <ResetPasswordScreen
          ResetPasswordScreenIsOpen={ResetPasswordScreenIsOpen}
          setResetPasswordScreenIsOpen={setResetPasswordScreenIsOpen}
          loginFormData={loginFormData}
          setLoginFormData={setLoginFormData}
        />

        <ForgotPasswordScreen
          ForgotPasswordScreenIsOpen={ForgotPasswordScreenIsOpen}
          setForgotPasswordScreenIsOpen={setForgotPasswordScreenIsOpen}
        />

        <TwoFactorAuthScreen
          TwoFactorAuthScreenIsOpen={TwoFactorAuthScreenIsOpen}
          setTwoFactorAuthScreenIsOpen={setTwoFactorAuthScreenIsOpen}
          twoFactorData={twoFactorData}
          setTwoFactorData={setTwoFactorData}
          loginFormData={loginFormData}
        />
      </Grid>
    </Box>
  );
}

export default Login;
